enum EventName {
  Resize = 'resize',
  PrintAutosize = 'print-autosize',
  ForcePrint = 'force-print',
}

export default EventName;
